import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { IEmailLog } from '@nxsys/types/models/emailLog';
import React from 'react';

type ViewEmailLogModalProps = {
  isOpen: boolean;
  toggle: () => void;
  data?: IEmailLog;
};

const ViewEmailLogModal: React.FC<ViewEmailLogModalProps> = ({
  isOpen,
  toggle,
  data,
}: ViewEmailLogModalProps) => {
  const { messages } = useTypedIntl();

  return (
    <AppModalContainer
      title={messages['common.emailContent']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.close'],
          variant: 'outlined',
          onClick: toggle,
        },
      ]}
      minHeight="200px"
    >
      <div dangerouslySetInnerHTML={{ __html: data?.dataSend?.html || '' }} />
    </AppModalContainer>
  );
};

export default ViewEmailLogModal;
